<template>
  <master-layout id="contentResourceSessions">
    <div
      v-if="!loading"
      class="lg:overflow-hidden flex flex-row justify-center relative font-aktiv-grotesk pb-[64px] md:pb-[68px] lg:pb-[142px] w-[100vw]"
    >
      <ResourcesContainer ref="resourceContainer">
        <div class="font-aktiv-grotesk">
          <ResourcesSection />
        </div>
      </ResourcesContainer>
    </div>
    <div
      v-if="loading"
      class="w-screen h-screen flex items-center justify-center"
    >
      <loading-state />
    </div>
  </master-layout>
</template>

<script>
import {
  Swiper as SwiperClass,
  Pagination,
  EffectCoverflow,
} from "swiper/core";
import ResourcesContainer from "../../components/ResourcesPage/ResourcesContainer.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import LoadingState from "@/components/common/LoadingState.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import PopupModal from "@/components/common/PopupModal.vue";
import ResourcesSection from "@/components/ResourcesPage/PlaybackResources/ResourcesSection.vue";

SwiperClass.use([Pagination, EffectCoverflow]);

export default {
  name: "SessionsPage",
  components: {
    ResourcesContainer,
    LoadingState,
    Swiper,
    SwiperSlide,
    PopupModal,
    ResourcesSection,
  },
  computed: {
    ...mapState("cms", ["sessionMaterials", "loading", "resources"]),
    ...mapState("filter", [
      "sessions",
      "showFilterModal",
      "allResources",
      "selectedFilter",
    ]),
  },
  async ionViewWillEnter() {
    this.setLoading(true);
    const locale = "en";
    // use Promise.all to fetch all the data at once
    await Promise.all([
      this.$store.dispatch("filter/fetchSchedule", {
        locale: locale,
        conferenceType: "GIC",
      }),
      this.$store.dispatch("filter/fetchAllResources", {
        locale: locale,
        conferenceType: "GIC",
      }),
      this.$store.dispatch("filter/fetchSearchSuggestions", {
        locale: locale,
        conferenceType: "GIC",
      }),
      this.$store.dispatch("filter/updateFilteredItems", {
        filteredItems: [],
      }),
      this.$store.dispatch("filter/fetchBookMarkLists", {
        locale: locale,
        conferenceType: "GIC",
      }),
    ]);
    this.$nextTick(() => {
      this.setLoading(false);
    });
  },
  async ionViewDidLeave() {
    const showFilterModal = false;
    await this.$store.dispatch("filter/updateShowFilterModal", {
      showFilterModal,
    });
    await this.$store.dispatch("filter/clearState");
  },
  methods: {
    ...mapActions("cms", ["setLoading"]),
  },
};
</script>

<style scoped>
.tool-shadow {
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}

.shadow {
  box-shadow: 0px 1px 25px 0px rgba(0, 0, 0, 0.25);
}

.swiper-slide {
  max-width: 328px;
  align-items: flex-start;
  vertical-align: middle;
  border-radius: 10px;
  display: flex;
  -webkit-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.swiper-container {
  list-style: none;
  z-index: 1;
  padding-bottom: 0px;
}

.download-button svg {
  fill: #00aae4;
}

.download-button:active svg {
  fill: #ffffff;
}

@media all and (min-width: 768px) {
  ::v-deep(.swiper-wrapper) {
    padding-left: 0;
  }
}
</style>
